"use strict";
// QNA 클릭 이벤트
const qTab = document.querySelectorAll('.q-tab p');
const aLists = document.querySelectorAll('.a-tab .a-list');
const shareBtn = document.querySelector('#link_copy');
qTab.forEach((tab) => {
    tab.addEventListener('click', () => {
        if (document.querySelector('.q-tab p.active')) {
            document.querySelector('.q-tab p.active').classList.remove('active');
        }
        tab.classList.add('active');
    });
});
// 링크 복사 버튼
shareBtn.addEventListener('click', () => {
    navigator.clipboard.writeText(window.location.href);
    alert('URL이 복사되었습니다.');
});
// 스크롤 이동 이벤트
const paragraphs = document.querySelectorAll('.button-wrap p');
paragraphs.forEach(paragraph => {
    paragraph.addEventListener('click', () => {
        const pId = paragraph.id;
        const targetDiv = document.querySelector(`.${pId}`);
        const targetPosition = targetDiv.getBoundingClientRect().top + window.scrollY - 65;
        window.scrollTo({ top: targetPosition, behavior: 'smooth' });
    });
});
// 텍스트 떠오르는 효과
const articles = Array.from(document.getElementsByTagName("article"));
const articleObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.style.transform = 'translateY(0px)';
            entry.target.style.opacity = '1';
        }
    });
}, {
    threshold: 0.2,
});
let lastIntersectingElement = null;
const weightObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            if (document.getElementById(`${entry.target.className}`)) {
                if (lastIntersectingElement !== entry.target) {
                    paragraphs.forEach(p => p.style.fontWeight = '500');
                    document.getElementById(`${entry.target.className}`).style.fontWeight = '900';
                }
            }
            lastIntersectingElement = entry.target;
        }
        else {
            document.getElementById(`${entry.target.className}`) ? document.getElementById(`${entry.target.className}`).style.fontWeight = '500' : null;
        }
    });
}, {
    threshold: 0.5, // 적절한 threshold를 설정합니다
});
articles.forEach((box) => {
    articleObserver.observe(box);
    weightObserver.observe(box);
});
//자세히보기 버튼 클릭 이벤트
const lookMore = document.querySelector('.look-more');
const contents = document.querySelector('.contents');
lookMore.addEventListener('click', () => {
    const targetPosition = contents.getBoundingClientRect().top + window.scrollY - 56;
    window.scrollTo({ top: targetPosition, behavior: 'smooth' });
});
